import {
    SET_OPEN_POPUP,
    SET_CLOSE_POPUP,
    SET_STATUS_POPUP_REVOKE_SHARE
} from '@jumbo/constants/ActionTypes';

let init = {
    isOpenPopupInfoAccount: false,
    isOpenPopupRevokeShare: false
};

export default (state = init, action) => {
    switch (action.type) {
        case SET_OPEN_POPUP: {
            return {
                isOpenPopupInfoAccount: true,
            };
        }
        case SET_CLOSE_POPUP: {
            return {
                isOpenPopupInfoAccount: false,
            };
        }
        case SET_STATUS_POPUP_REVOKE_SHARE: {
            return {
                ...state,
                isOpenPopupRevokeShare: action.payload
            }
        }
        default:
            return state;
    }
};
